import { render, staticRenderFns } from "./TechGroup.vue?vue&type=template&id=e67cf662&scoped=true&"
import script from "./TechGroup.js?vue&type=script&lang=js&"
export * from "./TechGroup.js?vue&type=script&lang=js&"
import style0 from "./TechGroup.vue?vue&type=style&index=0&id=e67cf662&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e67cf662",
  null
  
)

export default component.exports